import { Link } from 'react-router-dom'
import Placeholder from '../components/ui/Placeholder.jsx'

export default function NotFound() {
  return (
    <Placeholder screen="Not found" purpose="No route matches this address.">
      <Link to="/chats">Go to Chats</Link>
    </Placeholder>
  )
}
